/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// pcg-core: Reject File Gate (cardiac plausibility gate) accessors
// (core-viewer.js 3307-3327). rejectGateDetailsHtml (3328-3389) is a render
// function, rewritten as JSX in cards/reject-gate-panel.tsx.

export function rejectGate(payload) {
  return (
    payload.cardiacPlausibilityGate || (payload.examPackage && payload.examPackage.cardiac_plausibility_gate) || null
  )
}

export function isGateHardRejected(gate) {
  if (!gate) return false
  if (gate.gate_decision) return gate.gate_decision === "rejected"
  return gate.status === "reject"
}

export function gateClinicalSummary(gate) {
  if (!gate) return null
  const status = gate.status || gate.action || "unknown"
  const decision = gate.gate_decision || (status === "reject" ? "rejected" : "accepted")
  const use = gate.system_clinical_use || (decision === "rejected" ? "not_usable" : "hcp_review_required")
  const inclusion = gate.report_inclusion || (decision === "rejected" ? "blocked_hard" : "blocked_pending_hcp_review")
  const analyzability =
    gate.analyzability || (decision === "rejected" ? "none" : status === "pass" ? "full" : "limited")
  return { status, decision, use, inclusion, analyzability }
}

export function rejectGateMetrics(payload) {
  const gate = rejectGate(payload)
  return (gate && gate.metrics) || {}
}
